export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const GET_ALERTS = 'GET_ALERTS';
export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERTS_ERROR = 'GET_ALERTS_ERROR';
export const EDIT_ALERT = 'EDIT_ALERT';
export const EDIT_ALERT_SUCCESS = 'EDIT_ALERT_SUCCESS';
export const EDIT_ALERT_ERROR = 'EDIT_ALERT_ERROR';
export const SEND_ALERT_SUCCESS = 'SEND_ALERT_SUCCESS';
export const SEND_ALERT_ERROR = 'SEND_ALERT_ERROR';
export const ADD_ALERT = 'ADD_ALERT';
export const UPDATE_USER_PREFERENCES = 'UPDATE_USER_PREFERENCES';
export const UPDATE_WEB_NOTIFICATIONS = 'UPDATE_WEB_NOTIFICATIONS';
export const FETCH_WEB_NOTIFICATIONS = 'FETCH_WEB_NOTIFICATIONS';
export const GET_NOTIFICATION_PREFERENCES = 'GET_NOTIFICATION_PREFERENCES';
export const GET_NOTIFICATION_PREFERENCES_ERROR = 'GET_NOTIFICATION_PREFERENCES_ERROR';
export const UPDATE_ENABLE_NOTIFICATIONS_TOGGLE = 'UPDATE_ENABLE_NOTIFICATIONS_TOGGLE';
export const UPDATE_TOGGLE_STATE = 'UPDATE_TOGGLE_STATE';
export const UPDATE_ALERT = 'UPDATE_ALERT';
export const TOGGLE_NOTIFICATIONS_DRAWER = 'TOGGLE_NOTIFICATIONS_DRAWER';
export const TOGGLE_NOTIFICATIONS_PREFRENCE = 'TOGGLE_NOTIFICATIONS_PREFRENCE';
export const UPDATE_ALERT_SUCCESS = 'UPDATE_ALERT_SUCCESS';
export const UPDATE_ALERT_ERROR = 'UPDATE_ALERT_ERROR';
export const FREQUENCY_NEVER = 'Never';
export const FREQUENCY_IMMEDIATELY = 'Immediately';
export const LOADER = 'Loader';
export const TURN_LOADER_OFF = 'TURN_LOADER_OFF';
export const CONTRACTS = 'Contracts';
export const ORDERS = 'Orders';
export const DOCUMENTS = 'Documents';

// web-notifications
export const CONTRACT_NOTIFICATION = 'contractnotification';
export const NOTIFICATION_ENABLE_URL = 'enableNotificationUrl';
export const FROM_NOTIFICATIONS = '?from=notifications';
export const ORDER_NOTIFICATION = 'ordernotification';
export const ORDER_NOTIFICATION_ADDITIONAL = 'ordernotificationadditional';
export const REMOVED_TECH_DOC_NOTIFICATION = 'removedtechdocnotification';
export const UPDATED_TECH_DOC_NOTIFICATION = 'updatedtechdocnotification';
export const REMOVED_PROD_DOC_NOTIFICATION = 'removedproductdocnotification';
export const UPDATED_PROD_DOC_NOTIFICATION = 'updatedproductdocnotification';
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION';
export const DELETE_ALL_NOTIFICATIONS = 'DELETE_ALL_NOTIFICATIONS';
export const SUCCESS = 'Success';
export const NOTIFICATION_READ = 'NOTIFICATION_READ';
export const NOTIFICATION_READ_EXCEPTION = 'NOTIFICATION_READ_EXCEPTION';
export const PAGE_RELATIVE_PATH = 'pageRelativePath';
export const CONTRACTS_WITH_SMALL_C = 'contracts';
export const DXP_FOOD_ACCGRP_CONTRACTS = 'dxp_food_accgrp_contracts';
export const DXP_FOOD_ACCGRP_ORDERS = 'dxp_food_accgrp_orders';
export const DXP_FOOD_ACCGRP_DOCUMENTS = 'dxp_food_accgrp_documents';
export const ORDER_VALUE_LABEL = 'order value';

export const READ = 'READ';
export const OPEN = 'OPEN';
export const DELETE = 'DELETE';

export const OPEN_NOTIFICATION_DRAWER = 'OPEN_NOTIFICATION_DRAWER';
export const CHANGE_BADGE = 'CHANGE_BADGE';
export const SHOW_ALL = 'SHOW_ALL';
export const SHOW_UNREAD = 'SHOW_UNREAD';

export const MIME_TYPE_CSV = 'text/csv';
export const SEND_PAYMENT_REMINDER_ALERT = 'SEND_PAYMENT_REMINDER_ALERT';

export const ALERT_CODE_CONTRACT_UPLOADED = 1;
export const ALERT_CODE_CONTRACT_EXPIRY = 2;
export const ALERT_CODE_PAYMENT_REMINDER = 100;
export const ALERT_CODE_PAYMENT_SIGHTED = 101; // RED
export const ALERT_CODE_PAYMENT_UPLOADED = 102;
export const ALERT_CODE_PAYMENT_DUE = 104;
export const ALERT_CODE_TOTAL_APPROVED_QUANTITY_UPLOAD = 103; // RED
export const ALERT_CODE_PICKUP_SCHEDULE_ADDED = 201; // YELLOW
export const ALERT_CODE_PICKUP_SCHEDULE_DENIED = 202; // RED
export const ALERT_CODE_PICKUP_SCHEDULE_APPROVED = 203;

export const ACTION_ALERT = 'ACTION_ALERT';
export const SEND_ALERT = 'SEND_ALERT';

export const ACTION_ALERT_TYPE_PAYMENTS = 'payments';
export const ACTION_ALERT_TYPE_OVERVIEW = 'overview';
export const ACTION_ALERT_TYPE_SHIPPING = 'shipping';

export const REGISTER_ACTION_ALERT_COMPONENT = 'REGISTER_ACTION_ALERT_COMPONENT';
export const ACTION_ALERT_COMPONENT_DID_MOUNT = 'ACTION_ALERT_COMPONENT_DID_MOUNT';
export const CONTRACT_STATUS_FLAG = 'status';

export const EDIT_CONTRACT_FLAG = 'update';
export const STATUS_COMPLETED = 'Completed';
export const STATUS_UNSIGNED = 'Unsigned';

export const LEFT_NAV_CLOSE = 'leftNavClose';
export const LEFT_NAV_OPEN = 'leftNavOpen';
export const CHECKIN_NAVIGATION_ID = 'checkin_checkout';
export const LOAD_CHECKIN_CHECKOUT = 'openCheckinCheckout';

export const DEFAULT_ERR_MSG = 'defaultErr';
export const CURRENT_BC_PATH = 'currentPathBC';
export const PREV_BC_PATH = 'prevPathBC';

export const NO_RESULTS_ERROR_CODE = 'F101';

/* data formats for Table */
export const VALUE = {
  NUMBER: 'number',
  STRING_FORMATTED: 'formatted',
  STRING_PLAIN: 'plain',
  LIST: 'list',
  GRID: 'grid'
};

export const SUBSCRIBER_LOADED = 'subscriber_loaded';

export const LEFT = 'left';
export const RIGHT = 'right';
export const BOTH = 'both';
export const ALL = 'all';

export const GET_PERMISSIONS = 'getPermissions';

export const SORT_ASC = 'asc';
export const SORT_DESC = 'desc';
export const DO_SORT_DESC = 'DESC';

export const SELECT_ARROW_COLOR = '#546E7A';

export const FILTER_TOGGLE_ICON_COLOR = '#333333';
export const GET_ALL_MESSAGE_TYPE = 'NOTIFICATIONCENTER';
export const GET_PORTAL_MESSAGE_TYPE = 'INPORTAL';

export const LIMIT = 10;
export const TOTAL_PAGE = 0;

export const ACTION_ALERT_TYPE_ALL = 'dolist/alldo';
export const ACTION_ALERT_TYPE_EDITED = 'dolist/editeddo';
export const ACTION_ALERT_TYPE_APPROVED = 'dolist/approveddo';
export const ACTION_ALERT_TYPE_REJECTED = 'dolist/rejecteddo';
export const ACTION_DELIVERY_REPORT_LIST = 'doreport';

export const ACTION_DELIVERY = 'deliveryorder';
export const ACTION_CONTRACT = 'contract';
export const TYPE_CHANGE_STATUS = 'change_status_web';

export const NOTIFICATION_TYPE = 'notificationType';

export const GET_SWITCHER_DATA = 'GET_SWITCHER_DATA';
export const UPDATE_SWITCHER_DATA = 'UPDATE_SWITCHER_DATA';
export const UPDATE_SWITCHER_DATA_SUCCESS = 'UPDATE_SWITCHER_DATA_SUCCESS';
export const UPDATE_SWITCHER_DATA_ERROR = 'UPDATE_SWITCHER_DATA_ERROR';
export const UPDATE_SWITCHER_DATA_ERROR_STATUS = 'UPDATE_SWITCHER_DATA_ERROR_STATUS';
export const GET_SWITCHER_DATA_SUCCESS = 'GET_SWITCHER_DATA_SUCCESS';
export const GET_SWITCHER_DATA_ERROR = 'GET_SWITCHER_DATA_ERROR';
export const SET_SWITCHER_DATA = 'SET_SWITCHER_DATA';
export const UPDATE_SWITCHER_DATA_BUYER = 'UPDATE_SWITCHER_DATA_BUYER';

export const ALERT_CODE_FROM_SETTINGS = '4'; // include 401 402 403 404

export const GET_USER_DATA = 'GET_USER_DATA';
export const GET_USER_DATA_SUCCESS = 'GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_ERROR = 'GET_USER_DATA_ERROR';

export const GET_USER_PERMISSION_DATA = 'GET_USER_PERMISSION_DATA';
export const GET_USER_PERMISSION_DATA_SUCCESS = 'GET_USER_PERMISSION_DATA_SUCCESS';
export const GET_USER_PERMISSION_DATA_ERROR = 'GET_USER_PERMISSION_DATA_ERROR';

export const USER_STATUS_ACTIVE = 'ACTIVE';
export const USER_STATUS_PROVISIONED = 'PROVISIONED';
export const USER_STATUS_RECOVERY = 'RECOVERY';

export const GET_FIRMS_DETAILS = 'getFirmDetails';
export const GET_FIRMS_DETAILS_LIST = 'getFirmDetailsList';
export const GROUP_USER = 'GROUP';
export const INDIVIDUAL_USER = 'INDIVIDUAL';
export const ERROR_CODE_10012 = '10012';

export const YYYY_MM_DD = 'YYYY-MM-DD';

export const ADD_EXTERNAL_USER = 'addExternalUser';
export const SAVE_SUCCESSFUL = 'saveSuccessful';
export const EXPIRE_SUCCESSFUL = 'expireSuccessful';
export const REINVITE_USER = 'reinvite_user';

export const EDIT_EXPIRE_USER = 'deactivateUser';
export const EDIT_REINVITE_USER = 'reinviteUser';

export const VALIDATE_TOKEN = 'validateToken';
export const SET_AUDIT_TRAIL = 'setAuditTrail';
export const GET_REPLAY_TOKEN = `getReplayToken`;

export const STATE_EXPIRED_LABEL = '已失效';

export const SETTING = 'setting';
export const RECORD = 'record';
export const OVER_RIDE_DO = 'overridedo';
export const PRODUCTION_SETTING = 'productionsetting';
export const FINANCE_SETTING = 'financesetting';
export const CONTRACT_SETTING = 'contractsetting';
export const PRODUCTION_RECORD = 'productionrecord';
export const FINANCE_RECORD = 'financerecord';
export const CONTRACT_RECORD = 'contractrecord';

export const DOWNLOADNOTICEFILE = 'downloadNoticeFile';
export const DOWNLOADNOTICEFILEITEM = 'downloadNoticeFileItem';
export const MIMETYPE = 'multipart/form-data';
export const FILENAME = '附件';
export const SITENAMELABEL = '全部卖方';

export const ACTION_TYPE = 'user management';
export const ACTION_NEW = 'new account creation';
export const ACTION_EDIT = 'edit';
export const ACTION_LOCK = 'lock';

// permission group for RequestASample - Internal user
export const REQUEST_SAMPLE_PERMISSION = 'DXP_Food_AccGrp_Request_Sample';
export const DXP_RED_CARPET_USER_GROUP = 'dxp_onboarding_externalusers';

export const GLOBALNAV_CONFIG = 'global.json';

export const JUDGE_REPLAY = {
  requests: [{ url: 'commodity-movements/cancelDo' }, { url: 'commodity-movements/createDo' }]
};

export const NOTIFY_TYPES = { SUCCESS: 'success', CAUTION: 'caution', ALERT: 'alert' };

export const IS_PRE_EXISTING_CART_CLEARED = 'isPreExistingCartCleared';
export const INLINE_TRANSLATIONS = 'inlineTranslations';
